import { ForwardedRef, forwardRef } from 'react';
import { Spinner } from 'react-bootstrap';
import css from './InfiniteScrollSpinner.module.scss';

export interface InfiniteScrollSpinnerProps {
  isValidating: boolean;
}

export const InfiniteScrollSpinner = forwardRef(
  (
    { isValidating }: InfiniteScrollSpinnerProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => (
    <div ref={ref} className={css.container}>
      {isValidating && (
        <Spinner animation="border" className={css.spinner} role="status" />
      )}
    </div>
  )
);

InfiniteScrollSpinner.displayName = 'InfiniteScrollSpinner';
